import React, { useEffect, useMemo, useState } from "react";
import { LS } from "src/config/constants";
import { monitoringClient } from "src/services/requestClient";
import { useWeb3Connect } from "src/wallet-connection/context/we3-connect-context";

const UserContext = React.createContext({});

const UserProvider = ({ children }) => {
  const { address } = useWeb3Connect();

  const [authorization, setAuthorization] = useState(null);
  const [role, setRole] = useState(null);
  const [roleLoading, setRoleLoading] = useState(false);

  const _setAuthorization = (walletAddress, _authorization) => {
    setAuthorization(_authorization);
    if (_authorization) localStorage.setItem(`${LS.AUTHORIZATION}_${walletAddress}`, _authorization);
    else localStorage.removeItem(`${LS.AUTHORIZATION}_${walletAddress}`);
  };

  const setUserConfig = async (authorizationString, walletAddress, role) => {
    setRoleLoading(true);
    _setAuthorization(walletAddress, authorizationString);
    if (authorizationString && role) setRole(role);
    else if (authorizationString) {
      try {
        const _roleData = await monitoringClient.get(`/auth/check-user?jwt=${authorizationString}`);
        setRole(_roleData.role);
      } catch (error) {
        console.error(error);
        setRole(null);
        _setAuthorization(walletAddress, null);
      }
    } else setRole(null);
    setRoleLoading(false);
  };

  useEffect(() => {
    if (address) {
      const _authorization = localStorage.getItem(`${LS.AUTHORIZATION}_${address}`);
      setUserConfig(_authorization, address, null);
    } else {
      setAuthorization(null);
      setRole(null);
    }
  }, [address]);

  const contextData = useMemo(() => {
    return {
      authorization,
      role,
      setUserConfig,
      roleLoading,
    };
  }, [authorization, role, roleLoading]);

  return <UserContext.Provider value={contextData}>{children}</UserContext.Provider>;
};

export default UserProvider;

export const useUserContext = () => React.useContext(UserContext);

export const useUserSelector = (selectorFn) => {
  const result = useUserContext();
  return useMemo(() => selectorFn(result), [result]);
};
